import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Language from 'constants/language';
import FUEL_TYPES_ENGLISH from './fuel_types_en.json';
import FUEL_TYPES_NORWEGIAN from './fuel_types_no.json';
const useFuelType = () => {
  const {
    i18n
  } = useTranslation();
  const [fuelTypeList, setFuelTypeList] = useState(FUEL_TYPES_NORWEGIAN);
  const getCodes = Object.keys(fuelTypeList);
  const getFuelName = fuelCode => {
    const fuel = Object.entries(fuelTypeList).find(fuelEntry => fuelEntry[0] === fuelCode);
    if (fuel) return fuel[1].codeName;
    return fuelCode;
  };
  useEffect(() => {
    return i18n.languages[0] === Language.norwegian ? setFuelTypeList(FUEL_TYPES_NORWEGIAN) : setFuelTypeList(FUEL_TYPES_ENGLISH);
  }, [i18n.languages]);
  return {
    getCodes,
    fuelTypeList,
    getFuelName
  };
};
export default useFuelType;